import { styled } from 'linaria/react';

export const ChooseKeycardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (width <= 720px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const KeycardWrapper = styled.div<{ pro: boolean }>`
  width: 284px;
  height: 222px;
  border-radius: var(--rounding-l);
  background-color: ${(props) => (props.pro ? 'var(--brand-secondary)' : 'var(--brand-primary)')};
  padding: 24px;

  @media (width <= 720px) {
    width: 100%;
    height: auto;
  }
`;

export const IconsLine = styled.div<{ pro: boolean }>`
  display: flex;
  justify-content: space-between;

  --keycard-key-color: ${(props) => (props.pro ? 'var(--brand-primary)' : 'var(--brand-secondary)')};
  --keycard-hole-color: ${(props) => (props.pro ? 'var(--brand-primary)' : 'var(--brand-secondary)')};
`;

export const TextLine = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 0 24px;
  white-space: pre-wrap;
`;

export const KeycardChooseLinkButton = styled.a`
  text-decoration: underline;
  color: rgb(90 94 96 / 100%);
`;

export const MarketingConsentCheckboxWrapper = styled.div`
  margin-top: 8px;
  color: rgb(90 94 96 / 100%);

  ::before {
    inset: 0;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  min-height: 310px;

  gap: var(--space-200);
`;
